var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgColumnInsertLeft = function SvgColumnInsertLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 30h-6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2m-6-20v18h6V10zM6.365 9l5.586-5.586L10.537 2 6.365 6.172 2.193 2 .779 3.414zM29 30h-6a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2m-6-20v18h6V10z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z",
    "data-name": "<Transparent Rectangle>",
    style: {
      fill: "none"
    }
  }));
};
export default SvgColumnInsertLeft;